(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3565],{

/***/ 63706:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ customer_data_platform; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ./src/views/Pricing/assets/PricingOgImage.png
var PricingOgImage = __webpack_require__(53861);
var PricingOgImage_default = /*#__PURE__*/__webpack_require__.n(PricingOgImage);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/tracking/scripts/index.ts + 2 modules
var scripts = __webpack_require__(17397);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Pricing/CustomerDataPlatform/components/Addons/Addons.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var copy = {
  button: {
    text: "Get a demo",
    href: "/demo/"
  },
  cards: [{
    badge: "Engage",
    heading: "Audiences & profile enrichment",
    description: "Enhance every customer experience with profile, audience, and event data from the warehouse."
  }, {
    badge: "Engage",
    heading: "AI-recommended audiences",
    description: "Build more targeted audiences based on AI-powered product recommendations designed to drive conversions. "
  }]
};

var Addons = function Addons() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
        variant: "h2",
        children: "Add-ons"
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
        columns: 1,
        overrides: {
          lg: 2
        },
        children: copy.cards.map(function (copy) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.ZP, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardBody, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Label */.__, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
                    variant: "outlined",
                    children: copy.badge
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Headline */.s0, {
                  tag: "h2",
                  variant: "h3",
                  children: copy.heading
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Description */.dk, {
                  variant: "pMedium",
                  children: copy.description
                })]
              })
            })
          }, copy.heading);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
        variant: "filled",
        color: "primary",
        size: "medium",
        href: (0,getAbsoluteUrl/* default */.Z)(copy.button.href, pageConfig),
        onClick: function onClick() {
          return (0,scripts/* trackButtonClick */.kO)({
            buttonText: copy.button.text,
            targetUrl: copy.button.href,
            buttonId: "pricing-cdp-page-add-ons-section-demo"
          });
        },
        children: copy.button.text
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e1c8pl6d4"
} : 0)( true ? "" : 0);

var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1c8pl6d3"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e1c8pl6d2"
} : 0)( true ? {
  name: "1ib8u6k",
  styles: "max-width:844px"
} : 0);

var CardBody = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* Body */.uT,  true ? {
  target: "e1c8pl6d1"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{padding:56px;}" + ( true ? "" : 0));

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1c8pl6d0"
} : 0)(Section/* Wrapper */.im, "{gap:40px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px;}}" + ( true ? "" : 0));

/* harmony default export */ var Addons_Addons = (Addons);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Tooltip/index.ts + 2 modules
var Tooltip = __webpack_require__(57210);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TablePricing/index.tsx + 31 modules
var TablePricing = __webpack_require__(16410);
// EXTERNAL MODULE: ../../libs/matcha/recipes/TablePricing/Icons/index.ts + 1 modules
var Icons = __webpack_require__(88610);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
;// CONCATENATED MODULE: ./src/views/Pricing/CustomerDataPlatform/components/ComparePlans/data.tsx
var sections = function sections() {
  return [{
    header: "Complete view of your customer",
    rows: [{
      header: "Identity Resolution",
      tooltip: "Unify user history across web, mobile, server, data warehouse, and third-party touchpoints into one comprehensive profile.",
      cells: [true, true, true]
    }, {
      header: "Profile API",
      tooltip: "Query unified profiles to empower internal teams with customer data, and build real time in-app recommendations & personalized campaigns.",
      cells: [true, true, true]
    }, {
      header: "Profiles Sync",
      tooltip: "Access real-time profile data in your warehouse to build data and ML models to lower acquisition costs, increase lifetime value, and more.",
      cells: [true, true, true]
    }, {
      header: "Profile Explorer UI",
      tooltip: "Enable any technical or business team within your organization to explore unified profiles in one place. ",
      cells: [true, true, true]
    }, {
      header: "Traits",
      tooltip: "Created more personalized customer experiences by appending calculated and queried customer data to unified profiles.",
      cells: [false, true, true]
    }, {
      header: "Predictive traits",
      tooltip: "Predict customer behavior using a no-code builder to power more timely, targeted, and precise personalized experiences on every channel.",
      cells: [false, true, true]
    }]
  }, {
    header: "Build personalized experiences with Twilio Engage",
    rows: [{
      header: "Audiences",
      tooltip: "Equip technical and business users to group unified profiles with an easy-to-use UI based on customer traits or interactions.",
      cells: [false, false, true]
    }, {
      header: "Generative Audiences",
      tooltip: "Create and launch complex audiences in minutes with a simple text prompt using generative AI",
      cells: [false, false, true]
    }, {
      header: "Journeys",
      tooltip: "Orchestrate and optimize personalized journeys to automate messaging across multiple channels based on real-time customer behavior.",
      cells: [false, false, true]
    }]
  }, {
    header: "Collect and send data anywhere",
    rows: [{
      header: "Sources",
      tooltip: "Collect the full customer view via one API and 450+ pre-built integrations across your apps, sales, support, payment & messaging experiences.",
      cells: [true, true, true]
    }, {
      header: "Destinations",
      tooltip: "Send your first-party data to 450+ tools including data warehouse, product analytics, advertising, email, and more.",
      cells: [true, true, true]
    }, {
      header: "Functions",
      tooltip: "Create custom sources and destinations with just 10 lines of JavaScript, to solve for unique use cases.",
      cells: [true, true, true]
    }, {
      header: "Reverse ETL",
      tooltip: "Activate data from the warehouse into 450+ tools for product analytics, advertising, email, and more.",
      cells: [true, true, true]
    }, {
      header: "Developer Tools",
      tooltip: "Set up, test, and swap new tools with a common UI and data observability.",
      cells: [true, true, true]
    }, {
      header: "Public API",
      tooltip: "Programmatically manage Segment workspaces, sources, destinations, and more via API.",
      cells: [true, true, true]
    }]
  }, {
    header: "Usage and billing",
    rows: [{
      header: "Monthly tracked users",
      tooltip: "The number of anonymous and logged-in visitors that you track with Segment.",
      cells: ["Custom volume", "Custom volume", "Custom volume"],
      subRows: [{
        header: "Throughput Limit",
        tooltip: "Your customer data comes in the form of API Calls and Objects. CDP plans are eligible for custom limits.",
        cells: ["Custom", "Custom", "Custom"]
      }]
    }, {
      header: "Seats",
      tooltip: "The number of teammates that can access your Segment workspace.",
      cells: ["Unlimited", "Unlimited", "Unlimited"]
    }, {
      header: "Payment method",
      cells: ["Invoice", "Invoice", "Invoice"]
    }, {
      header: "Contract length",
      cells: ["Unlimited", "Unlimited", "Unlimited"]
    }]
  }, {
    header: "Support",
    rows: [{
      header: "Email/web support",
      cells: [true, true, true]
    }, {
      header: "On-demand videos and documentation",
      tooltip: "Get up and running quickly with developer documentation and on-demand training.",
      cells: [true, true, true]
    }, {
      header: "Dedicated support",
      cells: ["Available", "Available", "Available"],
      subRows: [{
        header: "Customer Success Manager",
        tooltip: "Customer Success Manager may be included based on your annual agreement. Please ask your Account Executive for details.",
        cells: ["Available", "Available", "Available"]
      }, {
        header: "Advisory Services or Professional Services",
        tooltip: "Custom advisory services and professional services packages available. Please ask your Account Executive for details.",
        cells: ["+ Add-on", "+ Add-on", "+ Add-on"]
      }]
    }, {
      header: "Uptime SLA",
      tooltip: "Guaranteed API uptime.",
      cells: [true, true, true]
    }]
  }, {
    header: "Security",
    rows: [{
      header: "Account security",
      tooltip: "Protect your workspace with personalized security settings",
      cells: [true, true, true],
      subRows: [{
        header: "Multi-factor authentication",
        tooltip: "Provide an additional layer of security beyond your username and password by requiring secondary authentication.",
        cells: [true, true, true]
      }, {
        header: "Single sign-on",
        tooltip: "Centrally manage your policies for access with single sign-on (SSO).",
        cells: [true, true, true]
      }, {
        header: "Granular roles and user permissions",
        tooltip: "Control access to your sources and workspaces with fine-grained permissions to manage how your teammates interact with your data.",
        cells: [true, true, true]
      }]
    }, {
      header: "Certifications",
      tooltip: "To learn more about Segment's security and privacy program, and certifications and attestations.",
      cells: [true, true, true]
    }, {
      header: "HIPAA-eligibility",
      cells: ["Available", "Available", "Available"],
      tooltip: "Store and manage PHI within your workspace."
    }, {
      header: "Regional Segment (EU or US)",
      tooltip: "Segment offers regional infrastructure in both Europe and the US.",
      cells: [true, true, true]
    }]
  }];
};

/* harmony default export */ var data = (sections);
;// CONCATENATED MODULE: ./src/views/Pricing/CustomerDataPlatform/components/ComparePlans/ComparePlans.tsx


function ComparePlans_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




















var ComparePlans_copy = {
  heading: "Compare CDP plans"
};
var ComparePlans_link = {
  text: "Get a demo",
  url: "/demo/"
};

var ComparePlans = function ComparePlans() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var isDesktopResolution = (0,useMatchMedia/* default */.Z)(theme.breakpoints.up("xxl", false), true);
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ComparePlans_StyledSectionBase, {
    variant: "centered",
    id: "compare-plans",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          children: ComparePlans_copy.heading
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TablePricing/* default */.ZP, {
        columns: 3,
        scrollable: !isDesktopResolution,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TablePricing/* Header */.h4, {
          sticky: true,
          pinFirst: true,
          tokens: {
            top: isDesktopResolution ? 128 : 0
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* HeaderCell */.qN, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TablePricing/* HeaderCell */.qN, {
            title: "Unify",
            headingVariant: "pLargeBold",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
              variant: "pLargeBold",
              children: "Custom Pricing"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
              variant: "outlined",
              size: "medium",
              onClick: function onClick() {
                return (0,scripts/* trackButtonClick */.kO)({
                  buttonText: "Get a demo",
                  targetUrl: "/signup/",
                  buttonId: "pricing-cdp-page-unify-compare-table"
                });
              },
              children: "Get a demo"
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TablePricing/* HeaderCell */.qN, {
            title: "Unify Plus",
            headingVariant: "pLargeBold",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
              variant: "pLargeBold",
              children: "Custom Pricing"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
              variant: "outlined",
              size: "medium",
              onClick: function onClick() {
                return (0,scripts/* trackButtonClick */.kO)({
                  buttonText: " Get a demo",
                  targetUrl: "/signup/",
                  buttonId: "pricing-cdp-page-unify-plus-compare-table"
                });
              },
              children: "Get a demo"
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TablePricing/* HeaderCell */.qN, {
            title: "Engage",
            headingVariant: "pLargeBold",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
              variant: "pLargeBold",
              children: "Custom Pricing"
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
              href: (0,getAbsoluteUrl/* default */.Z)(ComparePlans_link.url, pageConfig),
              variant: "outlined",
              color: "primary",
              size: "medium",
              onClick: function onClick() {
                return (0,scripts/* trackButtonClick */.kO)({
                  buttonText: ComparePlans_link.text,
                  targetUrl: ComparePlans_link.url,
                  buttonId: "pricing-cdp-page-engage-compare-table"
                });
              },
              children: ComparePlans_link.text
            })]
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* Body */.uT, {
          children: data().map(function (section) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* SectionHeader */.M$, {
                children: section.header
              }), section.rows.map(function (row) {
                var _row$subRows;

                return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* Row */.X2, {
                    header: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* RowHeader */.yD, {
                      icon: row.tooltip && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                        label: row.tooltip,
                        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* InfoIcon */.sz, {
                          color: theme.palette.twilio.gray[40]
                        })
                      }),
                      children: row.header
                    }),
                    children: row.cells.map(function (cell, index) {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureCell, {
                        feature: cell
                      }, index);
                    })
                  }), row === null || row === void 0 ? void 0 : (_row$subRows = row.subRows) === null || _row$subRows === void 0 ? void 0 : _row$subRows.map(function (subRow) {
                    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* Row */.X2, {
                      header: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* RowSubHeader */.Do, {
                        icon: subRow.tooltip && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                          label: subRow.tooltip,
                          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* InfoIcon */.sz, {
                            color: theme.palette.twilio.gray[40]
                          })
                        }),
                        children: subRow.header
                      }),
                      children: subRow.cells.map(function (subRowCell, index) {
                        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureCell, {
                          feature: subRowCell
                        }, index);
                      })
                    }, subRow.header);
                  })]
                }, row.header);
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* EmptyRow */.O7, {})]
            }, section.header);
          })
        })]
      })
    })]
  });
};

var ComparePlans_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e14jzv5s1"
} : 0)( true ? {
  name: "hc6m9z",
  styles: "overflow:initial"
} : 0);

var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e14jzv5s0"
} : 0)( true ? {
  name: "1i9vogi",
  styles: "margin-top:0"
} : 0);

var FeatureCell = function FeatureCell(_ref) {
  var feature = _ref.feature;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TablePricing/* Cell */.bL, {
    children: typeof feature === "boolean" ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureIcon, {
      featureEnabled: feature
    }) : feature
  });
};

var FeatureIcon = function FeatureIcon(_ref2) {
  var featureEnabled = _ref2.featureEnabled;
  return featureEnabled ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icons/* CheckIcon */.n, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: "\u2014"
  });
};

/* harmony default export */ var ComparePlans_ComparePlans = (ComparePlans);
// EXTERNAL MODULE: ../../node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(24330);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Accordion/index.ts + 26 modules
var Accordion = __webpack_require__(83914);
// EXTERNAL MODULE: ../../libs/matcha/recipes/RichText/index.ts
var RichText = __webpack_require__(47756);
// EXTERNAL MODULE: ../../libs/utils/useActiveState/index.ts + 1 modules
var useActiveState = __webpack_require__(74864);
// EXTERNAL MODULE: ../../node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(82562);
;// CONCATENATED MODULE: ./src/views/Pricing/CustomerDataPlatform/components/Faq/data.ts

var faqs = [{
  title: "How can I estimate my MTUs?",
  description: {
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: "To get an idea of your MTU count, add your monthly active users to the number of anonymous visitors you get per month. Some tools also call this metric \"Monthly Unique Visitors.\"",
        nodeType: "text"
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}, {
  title: "Is there a free trial of the paid plans?",
  description: {
    content: [{
      data: {},
      content: [{
        data: {},
        content: [{
          data: {},
          marks: [],
          value: "Not for Customer Data Platform (CDP) plans. However, there is a 14-day free trial for the Connections Team plan. Learn more about ",
          nodeType: "text"
        }, {
          data: {
            uri: "/pricing/connections/"
          },
          content: [{
            data: {},
            marks: [],
            value: "Connections plans",
            nodeType: "text"
          }],
          nodeType: dist.INLINES.HYPERLINK
        }, {
          data: {},
          marks: [],
          value: ".",
          nodeType: "text"
        }],
        nodeType: dist.BLOCKS.PARAGRAPH
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}, {
  title: "Can I connect sources for real-time events and reverse ETL from my warehouse?",
  description: {
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: "Yes! Segment Customer Data Platform (CDP) enables your team to start anywhere and activate everywhere, including your data warehouse and 450+ sources. If you are interested in a reverse ETL only plan, ",
        nodeType: "text"
      }, {
        data: {
          uri: "/demo/"
        },
        content: [{
          data: {},
          marks: [],
          value: "contact us",
          nodeType: "text"
        }],
        nodeType: dist.INLINES.HYPERLINK
      }, {
        data: {},
        marks: [],
        value: ".",
        nodeType: "text"
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}, {
  title: "Does Segment handle billing for my Sources or Destinations services?",
  description: {
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: "No, you\u2019re responsible for accounts that you register with Sources, Integrations, and Warehouse providers, whether they are paid or free.",
        nodeType: "text"
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}, {
  title: "Do I need to have a data warehouse to use warehouses?",
  description: {
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: "Segment connects to your existing data warehouse and pipes in data collected from your Sources. You don't have to worry about the ETL or maintaining the data pipeline.",
        nodeType: "text"
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}, {
  title: "How can I buy Protocols?",
  description: {
    content: [{
      data: {},
      content: [{
        data: {},
        marks: [],
        value: "Protocols is included in each Customer Data Platform (CDP) plan.",
        nodeType: "text"
      }],
      nodeType: dist.BLOCKS.PARAGRAPH
    }],
    data: {},
    nodeType: dist.BLOCKS.DOCUMENT
  }
}];
;// CONCATENATED MODULE: ./src/views/Pricing/CustomerDataPlatform/components/Faq/FAQ.tsx


function FAQ_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var FAQ_data = {
  heading: "Frequently asked questions",
  faqs: faqs
};

var FAQ = function FAQ() {
  var items = new Array(FAQ_data.faqs.length).fill(false);

  var _useActiveState = (0,useActiveState/* useActiveState */.z)(items, {
    allowMultipleActive: true
  }),
      activeItems = _useActiveState.activeItems,
      toggle = _useActiveState.toggle;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FAQ_StyledSectionBase, {
    variant: "centered",
    id: "faq",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        centered: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          variant: "h2",
          dangerouslySetInnerHTML: {
            __html: sanitize_html_default()(FAQ_data.heading)
          }
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionContents, {
      children: activeItems.map(function (active, index) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* Header */.h4, {
            onClick: function onClick() {
              return toggle(index);
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* TitleWrapper */.$t, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Title */.Dx, {
                opened: active,
                tag: "h3",
                children: FAQ_data.faqs[index].title
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Icon */.JO, {
              opened: active
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Body */.uT, {
            children: active && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* ContentWrapper */.vs, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Text */.xv, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RichText/* default */.ZP, {
                  data: FAQ_data.faqs[index].description
                })
              })
            })
          })]
        }, "item-".concat(index));
      })
    })]
  });
};

var FAQ_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1csm6ex1"
} : 0)("overflow:inherit;", Section/* Wrapper */.im, "{justify-content:stretch;}" + ( true ? "" : 0));

var StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1csm6ex0"
} : 0)( true ? {
  name: "1h9b9cv",
  styles: "max-width:844px;width:100%"
} : 0);

/* harmony default export */ var Faq_FAQ = (FAQ);
;// CONCATENATED MODULE: ./src/views/Pricing/CustomerDataPlatform/components/GettingStarted/GettingStarted.tsx


function GettingStarted_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var GettingStarted_copy = {
  heading: "Get a custom price quote",
  description: "Customer Data Platform plans are designed to help your business achieve its customer activation use cases. Contact us for plan and add-on pricing.",
  buttonTitle: "Request a quote"
};

var GettingStarted = function GettingStarted() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCopyTextBase, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: GettingStarted_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: GettingStarted_copy.description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Content, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
          onClick: function onClick() {
            return (0,scripts/* trackButtonClick */.kO)({
              buttonText: GettingStarted_copy.buttonTitle,
              targetUrl: "/demo/",
              buttonId: "pricing-cdp-page-request-a-quote"
            });
          },
          children: GettingStarted_copy.buttonTitle
        })
      })]
    })
  });
};

var GettingStarted_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1w3tw7i3"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-bottom:80px;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1w3tw7i2"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e1w3tw7i1"
} : 0)( true ? {
  name: "1ib8u6k",
  styles: "max-width:844px"
} : 0);

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1w3tw7i0"
} : 0)( true ? {
  name: "1knm127",
  styles: "display:flex;width:100%;margin:0 auto;gap:24px;justify-content:center"
} : 0);

/* harmony default export */ var GettingStarted_GettingStarted = (GettingStarted);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
;// CONCATENATED MODULE: ./src/views/Pricing/CustomerDataPlatform/components/Hero/Hero.tsx


function Hero_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var Hero_copy = {
  heading: "Customer Data Platform pricing",
  description: "Unlock the potential of your engineering, marketing, and product teams with our customer data platform. Discover pricing options and learn more from Twilio Segment."
};
var Hero_button = {
  text: "Which plan is right for you?",
  url: "#compare-plans"
};

var Hero = function Hero() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Hero_Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinkWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/pricing", pageConfig),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
          tag: "span",
          size: "medium",
          iconStart: Common/* ChevronLeftIcon */.wy,
          children: "All pricing"
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroBase, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          variant: "h1",
          tag: "h1",
          children: Hero_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          children: Hero_copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
            href: Hero_button.url,
            onClick: function onClick() {
              return (0,scripts/* trackButtonClick */.kO)({
                buttonText: Hero_button.text,
                targetUrl: Hero_button.url,
                buttonId: "pricing-cdp-page-hero-compare"
              });
            },
            children: Hero_button.text
          })
        })]
      })
    })]
  });
};

var Hero_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "epksfp32"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.mint[10];
}, ";" + ( true ? "" : 0));

var StyledHeroBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "epksfp31"
} : 0)(recipes_Hero/* Wrapper */.im, "{padding-bottom:0px;gap:0;}" + ( true ? "" : 0));

var LinkWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "epksfp30"
} : 0)( true ? {
  name: "cf6478",
  styles: "max-width:1280px;margin:0 auto;padding:40px 40px 0 40px"
} : 0);

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/Pricing/CustomerDataPlatform/components/ImplementationOptions/assets/ImplementationOptions@2x.webp
var ImplementationOptions_2x = __webpack_require__(7392);
var ImplementationOptions_2x_default = /*#__PURE__*/__webpack_require__.n(ImplementationOptions_2x);
// EXTERNAL MODULE: ./src/views/Pricing/CustomerDataPlatform/components/ImplementationOptions/assets/ImplementationOptions.webp
var ImplementationOptions = __webpack_require__(36142);
var ImplementationOptions_default = /*#__PURE__*/__webpack_require__.n(ImplementationOptions);
// EXTERNAL MODULE: ./src/views/Pricing/CustomerDataPlatform/components/ImplementationOptions/assets/ImplementationOptions@2x.png
var assets_ImplementationOptions_2x = __webpack_require__(83848);
var assets_ImplementationOptions_2x_default = /*#__PURE__*/__webpack_require__.n(assets_ImplementationOptions_2x);
;// CONCATENATED MODULE: ./src/views/Pricing/CustomerDataPlatform/components/ImplementationOptions/ImplementationOptionsImage.tsx








var ImplementationOptionsImage = function ImplementationOptionsImage() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      media: theme.breakpoints.up("sm", false),
      type: "image/webp",
      srcSet: "".concat((ImplementationOptions_default()), ", ").concat((ImplementationOptions_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "980",
      height: "494",
      src: (assets_ImplementationOptions_2x_default()),
      alt: "Illustration: Implementation Options",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var ImplementationOptions_ImplementationOptionsImage = (ImplementationOptionsImage);
;// CONCATENATED MODULE: ./src/views/Pricing/CustomerDataPlatform/components/ImplementationOptions/ImplementationOptions.tsx


function ImplementationOptions_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











var ImplementationOptions_copy = {
  heading: "Complete CDP",
  description: "With Engage, Unify Plus, and Unify, companies can start anywhere and activate everywhere, including their data warehouse, to get the most out of their current tech stack.",
  columns: [{
    heading: "Real-time behavioral events",
    description: "Support real-time use cases by capturing events from native sources, build audiences, and orchestrate personalized journeys across 450+ destinations."
  }, {
    heading: "Warehouse data",
    description: "Leverage data already stored in the warehouse to enrich unified profiles, and build complex audiences to precisely target customers with personalized communications."
  }]
};

var ImplementationOptions_ImplementationOptions = function ImplementationOptions() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionComponent, {
    variant: "centered",
    id: "which-plan-is-right-for-you",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: ImplementationOptions_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pLarge",
          tag: "p",
          children: ImplementationOptions_copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ImplementationOptions_StyledSectionContents, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImplementationOptions_ImplementationOptionsImage, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
        columns: 1,
        overrides: {
          lg: 2
        },
        children: ImplementationOptions_copy.columns.map(function (column) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
              variant: "h3",
              tag: "h2",
              children: column.heading
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
              variant: "pLarge",
              children: column.description
            })]
          }, column.heading);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
        size: "medium",
        color: "primary",
        variant: "filled",
        href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
        onClick: function onClick() {
          return (0,scripts/* trackButtonClick */.kO)({
            buttonText: "Get a demo",
            targetUrl: "/demo/",
            buttonId: "pricing-cdp-page-complete-cdp-section-demo"
          });
        },
        children: "Get a demo"
      })]
    })]
  });
};

var SectionComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e10g23pw1"
} : 0)("overflow:hidden;max-width:980px;", Section/* Wrapper */.im, "{padding-top:120px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{padding-top:80px;}}" + ( true ? "" : 0));

var ImplementationOptions_StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e10g23pw0"
} : 0)( true ? {
  name: "p5oe00",
  styles: "display:flex;flex-direction:column;align-items:center;gap:44px"
} : 0);

/* harmony default export */ var components_ImplementationOptions_ImplementationOptions = (ImplementationOptions_ImplementationOptions);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/index.ts + 1 modules
var LogoCarousel = __webpack_require__(6087);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/data.tsx
var LogoCarousel_data = __webpack_require__(43787);
;// CONCATENATED MODULE: ./src/views/Pricing/CustomerDataPlatform/components/LogoCarousel/LogoCarousel.tsx


function LogoCarousel_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var logos = [LogoCarousel_data/* carouselLogos.ALLERGAN */.j.ALLERGAN, LogoCarousel_data/* carouselLogos.ANGI */.j.ANGI, LogoCarousel_data/* carouselLogos.AB_IN_BEV */.j.AB_IN_BEV, LogoCarousel_data/* carouselLogos.AUTODESK */.j.AUTODESK, LogoCarousel_data/* carouselLogos.AVANT */.j.AVANT, LogoCarousel_data/* carouselLogos.CAMPING_WORLD */.j.CAMPING_WORLD, LogoCarousel_data/* carouselLogos.CROSS_FIT */.j.CROSS_FIT, LogoCarousel_data/* carouselLogos.CRUNCHY_ROLL */.j.CRUNCHY_ROLL, LogoCarousel_data/* carouselLogos.CSAA */.j.CSAA, LogoCarousel_data/* carouselLogos.FRAME_IO */.j.FRAME_IO, LogoCarousel_data/* carouselLogos.FRASERS_GROUP */.j.FRASERS_GROUP, LogoCarousel_data/* carouselLogos.IBM */.j.IBM, LogoCarousel_data/* carouselLogos.IMAX */.j.IMAX, LogoCarousel_data/* carouselLogos.MADEIRA_MADEIRA */.j.MADEIRA_MADEIRA];

var LogoCarousel_LogoCarousel = function LogoCarousel() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSection, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLogoCarousel, {
      logos: logos
    })
  });
};

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1m62k1f1"
} : 0)(Section/* Wrapper */.im, "{gap:0;padding-bottom:0;}" + ( true ? "" : 0));

var StyledLogoCarousel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(LogoCarousel["default"],  true ? {
  target: "e1m62k1f0"
} : 0)( true ? {
  name: "1hcx8jb",
  styles: "padding:0"
} : 0);

/* harmony default export */ var components_LogoCarousel_LogoCarousel = (LogoCarousel_LogoCarousel);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/components/Paper/index.ts + 2 modules
var Paper = __webpack_require__(16164);
;// CONCATENATED MODULE: ./src/views/Pricing/CustomerDataPlatform/components/PlansCards/PlansCards.tsx


function PlansCards_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


















var getCards = function getCards(config, theme) {
  return [{
    badge: "Profiles",
    title: "Unify ",
    excerpt: "Unify enables teams to combine real-time events with warehouse data to build unified profiles and empower any team within the business to use trusted data to build 1:1 personalized experiences at scale.\n",
    button: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
      size: "medium",
      color: "primary",
      variant: "outlined",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", config),
      onClick: function onClick() {
        return (0,scripts/* trackButtonClick */.kO)({
          buttonText: "Get a demo",
          targetUrl: "/demo/",
          buttonId: "pricing-cdp-page-unify-plan-demo"
        });
      },
      children: "Get a demo"
    }),
    price: "Custom Pricing",
    benefitsHeading: "What you can do with Unify:",
    benefitsSubheading: "Enable engineering teams to:",
    benefits: ["Collect and unify real-time events with customer data in the warehouse", "Automatically generate identity-resolved profiles", "Enrich and activate unified profile data to 450+ destinations"]
  }, {
    badge: "Profiles + AI",
    title: "Unify Plus",
    excerpt: "Unify Plus provides your teams with all the capabilities in Unify and equips your business teams to create more targeted profiles using calculated and AI-powered predictive traits.\n",
    button: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
      size: "medium",
      color: "primary",
      variant: "outlined",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", config),
      onClick: function onClick() {
        return (0,scripts/* trackButtonClick */.kO)({
          buttonText: "Get a demo",
          targetUrl: "/demo/",
          buttonId: "pricing-cdp-page-unify-plus-plan-demo"
        });
      },
      children: "Get a demo"
    }),
    price: "Custom Pricing",
    benefitsHeading: "Everything in Unify AND:",
    benefitsSubheading: "Enable marketing teams to:",
    benefits: ["Create computed traits", "Leverage AI to create predictive traits"]
  }, {
    badge: "Adaptive Customer Engagement",
    title: "Engage",
    excerpt: "Engage is the most complete real-time CDP that enables your technical and business users to build and activate customer profiles and audiences anywhere.\n",
    button: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButton, {
      size: "medium",
      color: "primary",
      variant: "filled",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", config),
      onClick: function onClick() {
        return (0,scripts/* trackButtonClick */.kO)({
          buttonText: "Get a demo",
          targetUrl: "/demo/",
          buttonId: "pricing-cdp-page-engage-plan-demo"
        });
      },
      children: "Get a demo"
    }),
    price: "Custom Pricing",
    benefitsHeading: "Everything in Unify Plus AND:",
    benefitsSubheading: "Enable marketing teams to:",
    benefits: ["Create and manage audiences", "Build AI-powered predictive and generative audiences", "Orchestrate customer journeys and campaigns"],
    optionalBenefits: [["Audience & profile enrichment", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
      label: "Expand identity-resolved profiles to include all warehouse data",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* InfoIcon */.sz, {
        color: theme.palette.twilio.gray[40]
      })
    }, "info-icon")], ["AI-recommended audiences", (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
      label: "Build more targeted audiences based on AI-powered product recommendations designed to drive conversions",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* InfoIcon */.sz, {
        color: theme.palette.twilio.gray[40]
      })
    }, "info-icon")]]
  }];
};

var PlansCards = function PlansCards() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlansCards_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlansCards_StyledSectionBase, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
          columns: 1,
          overrides: {
            lg: 3
          },
          children: getCards(pageConfig, theme).map(function (card, index) {
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPaper, {
              elevation: 3,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
                  variant: "filledBlue",
                  children: card.badge
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                  tag: "h2",
                  variant: "h2",
                  children: card.title
                })]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "pMedium",
                children: card.excerpt
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Price, {
                variant: "pLarge",
                children: card.price
              }), card.button, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListHeading, {
                  variant: "pMedium",
                  children: card.benefitsHeading
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListSubheading, {
                  variant: "pMedium",
                  children: card.benefitsSubheading
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
                  children: card.benefits.map(function (benefit, index) {
                    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledListItem, {
                      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Benefit, {
                        variant: "pMedium",
                        children: Array.isArray(benefit) ? benefit.map(function (item) {
                          return item;
                        }) : benefit
                      })
                    }, "benefit-".concat(index));
                  })
                }), card.optionalBenefits && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListSubheading, {
                    variant: "pMedium",
                    tag: "p",
                    children: "Optional add-ons"
                  }, "Optional add-on"), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
                    children: card.optionalBenefits.map(function (benefit, index) {
                      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledListItem, {
                        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Benefit, {
                          variant: "pMedium",
                          children: Array.isArray(benefit) ? benefit.map(function (item) {
                            return item;
                          }) : benefit
                        })
                      }, "benefit-".concat(index));
                    })
                  })]
                })]
              })]
            }, index);
          })
        })
      })
    })
  });
};

var PlansCards_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ecy8way10"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var PlansCards_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ecy8way9"
} : 0)("max-width:1320px;", Section/* Wrapper */.im, "{padding-top:0;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("md");
}, "{row-gap:40px;}}" + ( true ? "" : 0));

var StyledDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* default */.Z,  true ? {
  target: "ecy8way8"
} : 0)( true ? {
  name: "1d0nbku",
  styles: "margin-top:24px"
} : 0);

var StyledPaper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Paper/* default */.Z,  true ? {
  target: "ecy8way7"
} : 0)("display:grid;background-color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.neutrals.white[100];
}, ";padding:24px;grid-template-rows:10% 25% repeat(4, min-content) 1fr;max-width:327px;justify-self:center;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("lg");
}, "{padding:32px;grid-template-rows:10% 22.5% repeat(4, min-content) 1fr;max-width:352px;}" + ( true ? "" : 0));

var StyledButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Button/* default */.Z,  true ? {
  target: "ecy8way6"
} : 0)( true ? {
  name: "16a84qv",
  styles: "width:100%;height:56px"
} : 0);

var Price = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ecy8way5"
} : 0)( true ? {
  name: "1fs678t",
  styles: "overflow:hidden;white-space:nowrap;font-weight:600"
} : 0);

var ListHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ecy8way4"
} : 0)( true ? {
  name: "16ceglb",
  styles: "font-weight:600"
} : 0);

var ListSubheading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ecy8way3"
} : 0)( true ? {
  name: "5bhc30",
  styles: "margin-bottom:8px"
} : 0);

var List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "ecy8way2"
} : 0)("margin-bottom:24px;padding-left:24px;", function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.up("lg");
}, "{margin-bottom:0;}" + ( true ? "" : 0));

var StyledListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "ecy8way1"
} : 0)( true ? {
  name: "1s3jk2e",
  styles: "list-style-image:url(\"data:image/svg+xml;charset=UTF-8,%3csvg width='12' height='9' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.045.667a.91.91 0 0 1 .025 1.305L5.031 8.126a.95.95 0 0 1-1.356 0L.93 5.33a.91.91 0 0 1 .025-1.305.954.954 0 0 1 1.331.025l2.067 2.106L9.714.692a.954.954 0 0 1 1.33-.025Z' fill='%23121C2D'/%3e%3c/svg%3e \");font-weight:400;padding:0 0 8px 8px"
} : 0);

var Benefit = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "ecy8way0"
} : 0)( true ? {
  name: "wgm2x7",
  styles: "margin:0;display:flex;gap:8px"
} : 0);

/* harmony default export */ var PlansCards_PlansCards = (PlansCards);
;// CONCATENATED MODULE: ./src/views/Pricing/CustomerDataPlatform/components/OtherOptions/OtherOptions.tsx


function OtherOptions_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var OtherOptions_copy = {
  title: "Focused on collecting customer data? Check out Connections",
  description: "Get started for free and collect real-time event data from 450+ pre-built sources, including the data warehouse, and send unified customer data to your favorite marketing and analytics tools.",
  button: {
    text: "View Connection plans",
    href: "/pricing/connections/"
  }
};
var content = {
  title: "Connections enables engineering teams to:",
  benefits: ["Collect and unify real-time event data with customer data in the warehouse", "Send customer data to 450+ destinations"]
};

var OtherOptions = function OtherOptions() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherOptions_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OtherOptions_StyledSectionBase, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherOptions_Title, {
          variant: "h2",
          children: OtherOptions_copy.title
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
          variant: "pLarge",
          children: OtherOptions_copy.description
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          variant: "filled",
          color: "primary",
          size: "medium",
          href: (0,getAbsoluteUrl/* default */.Z)(OtherOptions_copy.button.href, pageConfig),
          onClick: function onClick() {
            return (0,scripts/* trackButtonClick */.kO)({
              buttonText: OtherOptions_copy.button.text,
              targetUrl: OtherOptions_copy.button.href,
              buttonId: "pricing-cdp-page-view-connections-plans"
            });
          },
          children: OtherOptions_copy.button.text
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCardBase, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Body */.uT, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListTitle, {
                variant: "pMediumBold",
                children: content.title
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherOptions_List, {
                children: content.benefits.map(function (benefit) {
                  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherOptions_StyledListItem, {
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherOptions_Benefit, {
                      variant: "pMedium",
                      children: benefit
                    })
                  }, benefit);
                })
              })]
            })
          })
        })
      })]
    })
  });
};

var OtherOptions_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e124kts08"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.mint[10];
}, ";" + ( true ? "" : 0));

var OtherOptions_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e124kts07"
} : 0)("max-width:1280px;", Section/* Wrapper */.im, "{grid-template-columns:1fr;}" + ( true ? "" : 0));

var StyledCardBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* default */.ZP,  true ? {
  target: "e124kts06"
} : 0)( true ? {
  name: "1xdn0ot",
  styles: "max-width:478px"
} : 0);

var OtherOptions_Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e124kts05"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e124kts04"
} : 0)( true ? "" : 0);

var ListTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e124kts03"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);

var OtherOptions_List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e124kts02"
} : 0)("margin-bottom:24px;padding-left:24px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{margin-bottom:0;}" + ( true ? "" : 0));

var OtherOptions_StyledListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e124kts01"
} : 0)( true ? {
  name: "1s3jk2e",
  styles: "list-style-image:url(\"data:image/svg+xml;charset=UTF-8,%3csvg width='12' height='9' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M11.045.667a.91.91 0 0 1 .025 1.305L5.031 8.126a.95.95 0 0 1-1.356 0L.93 5.33a.91.91 0 0 1 .025-1.305.954.954 0 0 1 1.331.025l2.067 2.106L9.714.692a.954.954 0 0 1 1.33-.025Z' fill='%23121C2D'/%3e%3c/svg%3e \");font-weight:400;padding:0 0 8px 8px"
} : 0);

var OtherOptions_Benefit = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e124kts00"
} : 0)( true ? {
  name: "wgm2x7",
  styles: "margin:0;display:flex;gap:8px"
} : 0);

/* harmony default export */ var OtherOptions_OtherOptions = (OtherOptions);
;// CONCATENATED MODULE: ./src/views/Pricing/CustomerDataPlatform/CustomerDataPlatform.tsx



















var PricingCustomerDataPlatform = function PricingCustomerDataPlatform() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Customer Data Platform Pricing | Twilio Segment",
      pageDescription: "Unlock the potential of your engineering, marketing, and product teams with our customer data platform. Discover pricing options and learn more from Twilio Segment.",
      pageOG: (PricingOgImage_default()),
      themeColor: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlansCards_PlansCards, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_LogoCarousel_LogoCarousel, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_ImplementationOptions_ImplementationOptions, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ComparePlans_ComparePlans, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Addons_Addons, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherOptions_OtherOptions, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Faq_FAQ, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted_GettingStarted, {})]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "ebypfpo0"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var CustomerDataPlatform = (PricingCustomerDataPlatform);
;// CONCATENATED MODULE: ./src/pages/pricing/customer-data-platform.tsx



var customer_data_platform_PricingCustomerDataPlatform = function PricingCustomerDataPlatform() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerDataPlatform, {});
};

/* harmony default export */ var customer_data_platform = (customer_data_platform_PricingCustomerDataPlatform);

/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 18601:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing/customer-data-platform",
      function () {
        return __webpack_require__(63706);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83848:
/***/ (function(module) {

module.exports = "/_next/static/images/ImplementationOptions@2x-89d0c355ed59ac6e76dada544f97f31b.png";

/***/ }),

/***/ 36142:
/***/ (function(module) {

module.exports = "/_next/static/images/ImplementationOptions-84c04f4f78fc59699042bbf8461718e4.webp";

/***/ }),

/***/ 7392:
/***/ (function(module) {

module.exports = "/_next/static/images/ImplementationOptions@2x-2e793642d88685080d46c10ca276fe38.webp";

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,7209,8834,4330,1382,4136,8392,2073,7096,2429,7303,4488,948,3996,8187,8726,7960,6012,3922,8536,4881,5062,5818,1668,9774,2888,179], function() { return __webpack_exec__(18601); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);